import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalPortal from '../../../../../components/modal-portal';
import { useModal } from '../../../../../hooks/use-modal';
import { refreshDeliveryEmailTemplates, refreshShipmentEmailTemplates } from '../../../../../store/seller/seller.actions';
import { postEmailTemplate, putEmailTemplate } from '../../api';
import { TYPE, SHIPMENT_EMAILS_TAB } from '../../constants';
import messages from '../../messages';
import { apiError } from '../../on-api-error';
import { TemplateEditorModal } from '../editor';

/**
 * @param {object} props
 * @param {(props: { onClick: (template?: object, isTemplateCopy?: boolean) => void }) => React.ReactNode} props.children
 * @param {boolean} props.isConfigurationAllowed
 * @param {() => void} props.onSaved
 * @param {typeof import('../../constants').SHIPMENT_EMAILS_TAB | typeof import('../../constants').DELIVERY_EMAILS_TAB} props.selectedTab
 * @returns {React.JSX.Element}
 */
export const CreateUpdateTemplate = ({ children, isConfigurationAllowed, onSaved, selectedTab }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState();
  const [isCopy, setIsCopy] = useState(false);
  const { open, close, isOpen } = useModal();

  const onCloseModal = () => {
    close();
    setEmailTemplate(undefined);
    setIsCopy(false);
  };

  const dispatch = useDispatch();
  const onSaveTemplate = (name, subject, content) => {
    setIsSaving(true);
    const onPostPutSuccess = () => {
      onSaved();
      close();
      setIsSaving(false);
      if (selectedTab === SHIPMENT_EMAILS_TAB) {
        dispatch(refreshShipmentEmailTemplates());
        return;
      }
      dispatch(refreshDeliveryEmailTemplates());
    };
    const onPostPutFail = () => {
      apiError(messages.apiSaveError);
      setIsSaving(false);
    };

    if (!emailTemplate.templateId || isCopy) {
      const template = {
        name,
        subject,
        content,
        typeId: selectedTab === SHIPMENT_EMAILS_TAB ? TYPE.SHIPMENT : TYPE.DELIVERY,
      };
      postEmailTemplate(template).then(onPostPutSuccess).catch(onPostPutFail);
      return;
    }

    const template = {
      ...emailTemplate,
      name,
      subject,
      content,
    };
    putEmailTemplate(template).then(onPostPutSuccess).catch(onPostPutFail);
  };

  const onClick = (template = {}, isTemplateCopy = false) => {
    open();
    setEmailTemplate(template);
    setIsCopy(isTemplateCopy);
  };
  return (
    <>
      {children({ onClick })}
      {isOpen ? (
        <ModalPortal onClose={onCloseModal}>
          <TemplateEditorModal
            content={emailTemplate.content}
            isConfigurationAllowed={isConfigurationAllowed}
            isCopy={isCopy}
            isSaving={isSaving}
            name={emailTemplate.name}
            onSave={onSaveTemplate}
            subject={emailTemplate.subject}
            typeId={selectedTab === SHIPMENT_EMAILS_TAB ? TYPE.SHIPMENT : TYPE.DELIVERY}
          />
        </ModalPortal>
      ) : null}
    </>
  );
};
